import { Routes } from '@angular/router';

import * as AngularCore from '@lmnop/angular-core';
import * as AngularWebsiteCore from '@lmnop/angular-website-core';

import * as Public from './public';

export const ApplicationRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'home' },
    { path: 'home', component: Public.HomePage },
    //general routing
    ...AngularWebsiteCore.CommonRoutes,
    ...AngularCore.Routes,
];
